import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../ui/Loader";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";

export default function GrievanceList() {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  var navigate = useNavigate()
  useEffect(() => {
    const fetchGrievances = async () => {
      try {
        // build params conditionally
        const params =
          user?.role === "employee"
            ? { employeeId: user?.employeeProfile?._id }
            : {};

        const res = await axios.get(`${API_URL}grievance`, { params });

        setGrievances(res.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch grievances:", err);
        toast.error("Failed to fetch grievances");
      } finally {
        setLoading(false);
      }
    };

    fetchGrievances();
  }, [API_URL, user]); // ✅ Added 'user'


  // Helper function to create initials for the avatar
  const getInitials = (name) => {
    if (!name) return "NA";
    return name
      .split(" ")
      .map((n) => n[0]?.toUpperCase())
      .slice(0, 2)
      .join("");
  };


  const handleView = async (ticketId) => {
    try {
      const res = await axios.get(`${API_URL}grievance/${ticketId}`);
      navigate(`/grievance/view`, { state: res.data }); // ✅ Works!
    } catch (err) {
      console.error("Error viewing grievance:", err);
      toast.error("Failed to open grievance details");
    }
  };

  const [expandedMessages, setExpandedMessages] = useState({});

  // Add this toggle function
  const toggleMessage = (id) => {
    setExpandedMessages(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div className="w-full min-h-screen px-4">
      <p className="text-balance font-bold p-4">Grievance List</p>
      <div className="overflow-x-auto rounded-lg mx-4 shadow bg-white">
        {/* Desktop Header - Only visible on md and above */}
        <div className="hidden md:grid md:grid-cols-12 gap-4 items-center font-semibold text-gray-700 text-sm bg-gray-100 px-4 py-3 border-b">
          <p className="col-span-2">Employee</p>
          <p className="col-span-2">Subject</p>
          <p className="col-span-3">Message</p>
          <p className="col-span-2">Date</p>
          <p className="col-span-2">Status</p>
          <p className="col-span-1 text-right">Action</p>
        </div>

        {/* Loader / Empty / Data */}
        {loading ? (
          <Loader />
        ) : grievances.length === 0 ? (
          <p className="text-center text-gray-500 py-6">No grievances found.</p>
        ) : (
          grievances.map((g) => (
            <div
              key={g._id}
              className={`flex flex-col md:grid md:grid-cols-12 gap-4 items-start md:items-center px-4 py-4 border-b transition-all duration-200 hover:shadow-sm ${g.status === "unseen" ? "bg-gray-50" : "bg-white"
                }`}
            >
              {/* Employee */}
              <div className="flex items-center gap-3 w-full md:col-span-2 mb-3 md:mb-0">
                {/* Text Avatar */}
                <div className="w-10 h-10 rounded-full bg-[#2C4E86] text-white flex items-center justify-center font-semibold text-sm uppercase flex-shrink-0">
                  {getInitials(g.userName)}
                </div>
                <div className="min-w-0">
                  <p className="font-medium text-gray-800 truncate">
                    {g.userName || "N/A"}
                  </p>
                </div>
              </div>

              {/* Subject */}
              <p className="w-full md:col-span-2 font-medium text-gray-700 text-sm mb-2 md:mb-0 truncate">
                {g.subject}
              </p>

              {/* Message */}
              {/* Message with Read More/Less */}
              <div className="w-full md:col-span-3 text-gray-500 text-sm mb-2 md:mb-0">
                <p className="inline">
                  {expandedMessages[g._id]
                    ? g.message
                    : g.message?.slice(0, 20)}
                  {g.message?.length > 20 && !expandedMessages[g._id] && "..."}
                </p>
                {g.message?.length > 20 && (
                  <button
                    onClick={() => toggleMessage(g._id)}
                    className="ml-2 text-[#2C4E86] hover:text-blue-800 text-xs font-medium underline"
                  >
                    {expandedMessages[g._id] ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>

              {/* Date */}
              <p className="w-full md:col-span-2 text-gray-500 text-sm mb-2 md:mb-0">
                {new Date(g.createdAt * 1000).toLocaleDateString()}
              </p>

              {/* Status */}
              <div className="w-full md:col-span-2 mb-2 md:mb-0">
                <span
                  className={`inline-block text-center px-3 py-1 rounded-full text-xs font-semibold ${(user.role === "hr" ? g.hrStatus : g.employeeStatus) === "seen"
                      ? "bg-[#2C4E86] text-white"
                      : (user.role === "hr" ? g.hrStatus : g.employeeStatus) ===
                        "unseen"
                        ? "bg-red-500 text-white"
                        : (user.role === "hr" ? g.hrStatus : g.employeeStatus) ===
                          "send"
                          ? "bg-green-500 text-white"
                          : "bg-gray-300 text-gray-800"
                    }`}
                >
                  {user.role === "hr" ? g.hrStatus : g.employeeStatus}
                </span>
              </div>

              {/* Action */}
              <div className="w-full md:col-span-1 flex justify-start md:justify-end items-center mt-3 md:mt-0">
                <button
                  onClick={() => handleView(g.ticketId)}
                  className="bg-[#2C4E86] hover:bg-blue-900 text-white text-sm px-3 py-1 rounded transition"
                >
                  Chat
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>

  );
}
